import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import UrlForm from './forms/urlForm';
import UrlFieldForm from './forms/urlFieldForm';
import UrlList from './lists/urlList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";

class EmptyList extends React.Component {
    render() {
        return null;
    }
}

class FieldEditor extends React.Component {
    render() {
        return (
            <Fragment>
                {this.props.children}
                <div className="col-md-3">
                    <div className="form-group">
                        <label className="control-label">&nbsp;</label>
                        <div className="row">
                            {this.props.footer}
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

class urlEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        let List = this.props.list || Box;
        let Editor = this.props.editor || BoxEditor;
        let Form = UrlForm;
        const newButton = this.props.generate ? <Button
            key="0"
            disabled={!!(!this.props.presets.component_type ? !this.props.dirty || this.props.isLoading : !this.props.presets.component_id || this.props.values[this.props.componentConfig.idfield] || this.props.isLoading)}
            block={!!this.props.presets.component_type}
            color="primary"
            onClick={this.saveForm}
        >
            Generálás
        </Button> : <Button
            key="0"
            disabled={!this.props.dirty || this.props.isLoading}
            block={!!this.props.presets.component_type}
            color="primary"
            onClick={this.saveForm}
        >
            Mentés
        </Button>;
        const actionButtons = [];
        if (this.props.presets.component_type) {
            Editor = FieldEditor;
            List = EmptyList;
            Form = UrlFieldForm;
            actionButtons.push(
                <div key="1" className="col-md-6">
                    {newButton}
                </div>
            );
            actionButtons.push(
                <div key="2" className="col-md-6">
                    <Button
                        key="1"
                        disabled={!this.props.values.url}
                        block={!!this.props.presets.component_type}
                        color="default"
                        onClick={() => {
                            window.open(this.props.values.url, '_blank');
                        }}
                    >
                        Megnyitás
                    </Button>
                </div>
            )
        } else {
            actionButtons.push(newButton);
        }
        List = <List
            {...this.props}
            collapsed={this.props.collapsed || false}
            theme="default"
            header={"Url-ek"}
            footer={[
                <Button
                    key="0"
                    disabled={this.props.isLoading}
                    color="default"
                    onClick={this.pristineForm}
                >
                    Új
                </Button>
            ]}
        >
            <UrlList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
        </List>;
        Editor = <Editor
            {...this.props}
            ref={(editor) => this.editor = editor}
            theme="default"
            header="Url"
            footer={actionButtons}
        >
            <Form {...this.props} />
        </Editor>;
        if (this.props.presets.component_type) {
            return <div className="row">
                {Editor}
                {List}
            </div>;
        } else {
            return <Fragment>
                {List}
                {Editor}
            </Fragment>;
        }
    }
}

export default createEditor({componentName: "url", WrappedComponent: urlEditor});
